var map = {
	"./1_establish_keep.mp4": "./src/video/1_establish_keep.mp4",
	"./3_construct_strategic_defense.mp4": "./src/video/3_construct_strategic_defense.mp4",
	"./5_recruit_wizards.mp4": "./src/video/5_recruit_wizards.mp4",
	"./trailer_combat_simple.mp4": "./src/video/trailer_combat_simple.mp4",
	"./trailer_combat_simple.webm": "./src/video/trailer_combat_simple.webm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/video sync \\.(mp4%7Cwebm)$";